import { API_AI } from 'Constants/client-modules';

import * as ACTION_TYPES from './types';

export function sendPrompt(threadId, body) {
  return {
    types: [
      ACTION_TYPES.AI_SEND_PROMPT_REQUESTED,
      ACTION_TYPES.AI_SEND_PROMPT_SUCCEED,
      ACTION_TYPES.AI_SEND_PROMPT_FAILED,
    ],
    promise: client => client.post(`threads/${threadId}/messages`, body),
    options: {
      clientName: API_AI,
    },
  };
}

export function checkHealthSummary(body) {
  return {
    types: [
      ACTION_TYPES.AI_CHECK_HEALTH_SUMMARY_REQUESTED,
      ACTION_TYPES.AI_CHECK_HEALTH_SUMMARY_SUCCEED,
      ACTION_TYPES.AI_CHECK_HEALTH_SUMMARY_FAILED,
    ],
    promise: client => client.post('consults/evaluate-clinical-note', body),
    options: {
      clientName: API_AI,
    },
  };
}

export const doctorEvaluate = (id, body) => {
  return {
    types: [
      ACTION_TYPES.AI_DOCTOR_EVALUATE_REQUESTED,
      ACTION_TYPES.AI_DOCTOR_EVALUATE_SUCCEED,
      ACTION_TYPES.AI_DOCTOR_EVALUATE_FAILED,
    ],
    promise: client => client.post(`consults/clinical-note-evaluations/${id}/feedback`, body),
    options: {
      clientName: API_AI,
    },
  };
};

export const getEvaluate = id => {
  return {
    types: [
      ACTION_TYPES.AI_GET_EVALUATE_REQUESTED,
      ACTION_TYPES.AI_GET_EVALUATE_SUCCEED,
      ACTION_TYPES.AI_GET_EVALUATE_FAILED,
    ],
    promise: client => client.get(`consults/clinical-note-evaluations/${id}`),
    options: {
      clientName: API_AI,
    },
  };
};
